import type { IAvatarFonts, IAvatarSize } from "./types";

/** Text classes and skeleton sizes per size. Initials scale in CSS. */
export const fontClassMap: Record<IAvatarSize, IAvatarFonts> = {
  xs: {
    title: "nuco-text nuco-text--sm",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-xs)",
    skeletonTitleWidth: "6.25rem",
    skeletonTitleHeight: "0.875rem",
    skeletonSubtextWidth: "4.375rem",
    skeletonSubtextHeight: "0.875rem",
  },
  sm: {
    title: "nuco-text nuco-text--md",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-sm)",
    skeletonTitleWidth: "8.125rem",
    skeletonTitleHeight: "1.125rem",
    skeletonSubtextWidth: "6.25rem",
    skeletonSubtextHeight: "0.75rem",
  },
  md: {
    title: "nuco-text nuco-text--md nuco-text--bold",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-md)",
    skeletonTitleWidth: "8.125rem",
    skeletonTitleHeight: "1.3125rem",
    skeletonSubtextWidth: "6.25rem",
    skeletonSubtextHeight: "1.125rem",
  },
  lg: {
    title: "nuco-heading nuco-heading--4",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-lg)",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
  xl: {
    title: "nuco-heading nuco-heading--4",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-xl)",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
  "2xl": {
    title: "nuco-heading nuco-heading--4",
    subtext: "nuco-text nuco-text--sm",
    skeletonImageSize: "var(--nuco-component-size-2xl)",
    skeletonTitleWidth: "9.375rem",
    skeletonTitleHeight: "1.5rem",
    skeletonSubtextWidth: "7.5rem",
    skeletonSubtextHeight: "1.125rem",
  },
};
